import React, { Component } from 'react';
import Slider from 'react-slick';
import Skeleton from 'react-loading-skeleton';

class TopCollectionLoading extends Component {

    render() {
        return (
            <div>
                <Skeleton height={200} />
            </div>
        )
    }
}


export default TopCollectionLoading;